'use strict';

// @flow

import * as React from 'react';
import { Panel } from 'react-bootstrap';

import type { IDocumento } from 'lib/api';

import { formatoTela } from '../common/detalhes_documento/formato_tela';
import LabelSituacao from './label_situacao';
import ClassificaDocumento from '../documento/classificacao_fiscal/classifica_documento';
import ComTooltip from '../common/com_tooltip';

type ClassificacaoFiscalProps = {
  documento : ?IDocumento
};

/**
 * Painel de informações de manifestação da CT-e.
 */
export default function ClassificacaoFiscal({ documento } : ClassificacaoFiscalProps) {
  if (!documento || !documento.classificacaoFiscal)
    return <span/>;

  const classificacao = documento.classificacaoFiscal;

  // Bloco responsável por mostrar a ultima atualização
  const dataAtualizacao = classificacao.classificacaoRealizadaEm ?
      <p>Atualizado:{ '  ' } { formatoTela('data', classificacao.classificacaoRealizadaEm ) }</p> :
      'Sem destinação.';

  return (
      <Panel className="situacoes">
        <Panel.Heading>Destinação</Panel.Heading>
        <Panel.Body>
          <dl>
            <dt><ComTooltip hint="Classificação referente à destinação da compra, informada pelo destinatário no Portal Consyste. Refere-se à nota no geral e não aos seus itens." posicao="top"><span>
            Classificação Geral
          </span></ComTooltip></dt>
            <dd><LabelSituacao { ...classificacao.opcaoClassificacao } /></dd>
            <dt><ComTooltip hint="Explicação informada pelo usuário que fez a classificação." posicao="top"><span>
            Observações
          </span></ComTooltip></dt>
            <dd><LabelSituacao { ...classificacao.observacoesClassificacao } /></dd>
          </dl>
          <div className="ultima-consulta r">
            { dataAtualizacao }
          </div>
          <ClassificaDocumento url={ classificacao.url }/>
        </Panel.Body>
      </Panel>
  );
}